(() => {
  const initGallery = (scope = document) => {
    scope.querySelectorAll('[data-packs]:not([data-pack-gallery-ready])').forEach((section) => {
      const frame = section.querySelector('[data-pack-image-frame]');
      const packImage = section.querySelector('[data-pack-image]');
      const photo = section.querySelector('[data-pack-gallery-photo]');
      const thumbs = [...section.querySelectorAll('[data-pack-gallery-thumb]')];
      const dialog = section.querySelector('[data-pack-gallery-dialog]');
      const dialogImage = section.querySelector('[data-pack-gallery-dialog-image]');
      const count = section.querySelector('[data-pack-gallery-count]');
      if (!frame || !packImage || !photo || !thumbs.length || !dialog || !dialogImage) return;

      section.dataset.packGalleryReady = 'true';
      const controller = new AbortController();
      const { signal } = controller;
      const arrows = {
        prev: section.querySelector('[data-pack-gallery-prev]'),
        next: section.querySelector('[data-pack-gallery-next]'),
        dialogPrev: section.querySelector('[data-pack-gallery-dialog-prev]'),
        dialogNext: section.querySelector('[data-pack-gallery-dialog-next]')
      };
      let index = 0;
      let previousOverflow = '';
      let scrollLocked = false;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const restoreScroll = () => {
        if (!scrollLocked) return;
        document.body.style.overflow = previousOverflow;
        scrollLocked = false;
      };

      const sourceFor = (number) => number === 0 ? packImage.src : thumbs[number].querySelector('img').src;
      const altFor = (number) => number === 0 ? packImage.alt : (thumbs[number].dataset.alt || thumbs[number].getAttribute('aria-label').replace(/^Ver imagen \d+: /, ''));

      const show = (number) => {
        index = Math.max(0, Math.min(thumbs.length - 1, number));
        frame.dataset.galleryIndex = String(index);
        const src = sourceFor(index);
        const alt = altFor(index);
        photo.hidden = index === 0;
        packImage.setAttribute('aria-hidden', String(index !== 0));
        if (index > 0) {
          photo.src = src;
          photo.alt = alt;
        }
        dialogImage.src = src;
        dialogImage.alt = alt;
        thumbs.forEach((thumb, thumbIndex) => {
          const active = thumbIndex === index;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', String(active));
        });
        if (arrows.prev) arrows.prev.hidden = index === 0;
        if (arrows.next) arrows.next.hidden = index === thumbs.length - 1;
        if (arrows.dialogPrev) arrows.dialogPrev.hidden = index === 0;
        if (arrows.dialogNext) arrows.dialogNext.hidden = index === thumbs.length - 1;
        if (count) count.textContent = `${index + 1} / ${thumbs.length}`;
        const rail = thumbs[index].parentElement;
        const thumbRect = thumbs[index].getBoundingClientRect();
        const railRect = rail.getBoundingClientRect();
        if (thumbRect.left < railRect.left || thumbRect.right > railRect.right) {
          rail.scrollTo({ left: rail.scrollLeft + thumbRect.left - railRect.left - (railRect.width - thumbRect.width) / 2, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        }
      };

      const syncPackImage = () => {
        const firstImage = thumbs[0].querySelector('img');
        firstImage.src = packImage.src;
        show(0);
      };

      thumbs.forEach((thumb, thumbIndex) => thumb.addEventListener('click', () => show(thumbIndex), { signal }));
      arrows.prev?.addEventListener('click', () => show(index - 1), { signal });
      arrows.next?.addEventListener('click', () => show(index + 1), { signal });
      arrows.dialogPrev?.addEventListener('click', () => show(index - 1), { signal });
      arrows.dialogNext?.addEventListener('click', () => show(index + 1), { signal });
      section.querySelector('[data-pack-gallery-open]')?.addEventListener('click', () => {
        if (typeof dialog.showModal !== 'function' || dialog.open) return;
        dialog.showModal();
        previousOverflow = document.body.style.overflow;
        scrollLocked = true;
        document.body.style.overflow = 'hidden';
      }, { signal });
      section.querySelector('[data-pack-gallery-close]')?.addEventListener('click', () => dialog.close(), { signal });
      dialog.addEventListener('close', restoreScroll, { signal });
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); }, { signal });

      [frame, dialog].forEach((target) => {
        let touchStart = null;
        target.addEventListener('touchstart', (event) => {
          const touch = event.touches.length === 1 ? event.touches[0] : null;
          touchStart = touch ? { id: touch.identifier, x: touch.clientX, y: touch.clientY } : null;
        }, { passive: true, signal });
        target.addEventListener('touchcancel', () => { touchStart = null; }, { passive: true, signal });
        target.addEventListener('touchend', (event) => {
          const start = touchStart;
          touchStart = null;
          if (!start || event.touches.length) return;
          const touch = [...event.changedTouches].find((item) => item.identifier === start.id);
          if (!touch) return;
          const dx = touch.clientX - start.x;
          const dy = touch.clientY - start.y;
          // Page scroll and pinch gestures must not navigate the gallery.
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
        }, { passive: true, signal });
      });
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') show(index + 1);
        if (event.key === 'ArrowLeft') show(index - 1);
      }, { signal });
      const imageObserver = new MutationObserver(syncPackImage);
      imageObserver.observe(packImage, { attributes: true, attributeFilter: ['src'] });
      const shopifySection = section.closest('.shopify-section') || section;
      shopifySection.addEventListener('shopify:section:unload', () => {
        if (dialog.open) dialog.close();
        // The native close event is queued; restore before aborting its listener.
        restoreScroll();
        controller.abort();
        imageObserver.disconnect();
        delete section.dataset.packGalleryReady;
      }, { once: true, signal });
      show(0);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initGallery(), { once: true });
  else initGallery();
  document.addEventListener('shopify:section:load', (event) => initGallery(event.target));
})();
